.modal-body h4{line-height:2em}
/*# sourceMappingURL=confirm-modal-6QLRUZU7.css.map */
